var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader--wrapper"},[_c('div',{staticClass:"loader",class:{active: _vm.loading }}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wave",attrs:{"id":"wave"}},[_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot"})])
}]

export { render, staticRenderFns }